export const SET_SELECTED_FILES = 'hierarchy/heading/bulkUploadFileSection/SET_SELECTED_FILES';
export const REMOVE_SELECTED_FILE = 'hierarchy/heading/bulkUploadFileSection/REMOVE_SELECTED_FILE';
export const CLEAR_FILE_SECTION = 'hierarchy/heading/bulkUploadFileSection/CLEAR_FILE_SECTION';

export const acceptedExtensions = { 'application/zip': ['.zip'] };
export const maxFileSize = 524288000;
